module.exports = __webpack_public_path__ + "img/qrcode.7070f0ad.jpg";